export function isOutputSlice(d) {
    return d.hasOwnProperty("name");
}
//# sourceMappingURL=plots.js.map